import { canv } from "@/canv/global.js";
import {
    createBlobFromString,
    isVoteCreateEvent,
    isVoteEndedEvent,
    logException,
    returnSanitizedCommentActionEvents,
    returnSanitizedVoteActionEvents,
    updateCommentsMessages,
} from "@/canv/utils.js";
import { enableAiButton, handlePropertyBuild, handlePropertyUpdate } from "@/intercom/helpers.js";
import { showSnackbar } from "@/snackbar/snackbar";

const SNACKBAR_TIMEOUT = 7000;

export class intercom {
    constructor() { }

    reConnect(path) {
        return new Promise((resolve, reject) => {
            if (canv.intercom.socket != null) {
                canv.intercom.socket.close();
            }

            canv.intercom.socket = new WebSocket(path);
            canv.intercom.socket.binaryType = "blob";
            canv.intercom.socket.onopen = () => {
                resolve("connected");
            };
            canv.intercom.socket.onerror = (err) => {
                var readable = "socket onError";
                if (!canv.isReconnectionProcess) {
                    //canv.appInterface.reconnectPanel.show();
                }
                reject("error");
            };
            canv.intercom.socket.onclose = (err) => {
                var readable =
                    "socket onClose. code=" + err.code + " reason=" + err.reason;
                if (!canv.isReconnectionProcess) {
                    //canv.appInterface.reconnectPanel.show();
                }
                reject("closed");
            };

            canv.intercom.socket.onmessage = canv.intercom.processResponse.bind(
                canv.intercom,
            );
        });
    }

    async initMessage() {
        return new Promise((resolve, reject) => {
            const data = {
                type: "init",
                board_uid: canv.getInitDataProp("boardUID"),
                token: canv.getInitDataProp("userToken"), // не используется
                boardAccessToken: canv.getInitDataProp("boardAccessToken"),
                jwt: canv.getInitDataProp("JWT"),
                clientUID: canv.getInitDataProp("clientUID"),
                prefix: canv.getInitDataProp("fePrefix"),
            };

            var blob = createBlobFromString(JSON.safeStringify(data));
            canv.intercom.socket.send(blob);

            canv.intercom.resolvers.initResolver = (data) => {
                resolve(data);
            };
        });
    }

    async requestDeskMessage() {
        return new Promise((resolve, reject) => {
            const data = {
                type: "deskRequest",
                desc_uid: canv.getInitDataProp("boardUID"), // не используется
            };

            var blob = createBlobFromString(JSON.safeStringify(data));
            canv.intercom.socket.send(blob);

            canv.intercom.resolvers.requestDeskResolver = (data) => {
                try {
                    const parsed = JSON.parse(data);
                    resolve(parsed.data);
                } catch (e) {
                    logException(e);
                    // тут не пишем reject. Бесконечно висим с await requestDeskMessage в месте вызова.
                }
            };
        });
    }

    async pingMessage() {
        return new Promise((resolve, reject) => {
            const data = {
                type: "pingRequest",
            };

            var blob = createBlobFromString(JSON.safeStringify(data));
            canv.intercom.socket.send(blob);

            canv.intercom.resolvers.pingResolver = (data) => {
                resolve();
            };

            setTimeout(() => {
                reject();
            }, 5000);
        });
    }

    async eventMessage(currentRecord) {
        const data = {
            type: "event",
            data: currentRecord,
        };

        if (this.disabled) return;
        if (this.disableEvents) return;

        var blob = createBlobFromString(JSON.safeStringify(data));
        canv.intercom.socket.send(blob);
    }

    async selectMessage(selectedGroups) {
        if (this.disabled) return;
        var uids = [];
        for (var i = 0; i < selectedGroups.length; i++) {
            uids.push(selectedGroups[i].UID);
        }

        const selectData = {
            sessionUID: canv.sessionUID,
            selectedGroups: uids,
        };

        this.fastMessage("select", selectData);
    }

    viewMessage(cursorPosition, viewPosition) {
        if (canv.highloadMode) return;

        const viewData = {
            sessionUID: canv.sessionUID,
            name: canv.getInitDataProp("userName"),
            login: canv.getInitDataProp("userEmail"),
            token: canv.getInitDataProp("userToken"),
            cursorPosition: cursorPosition,
            viewPosition: viewPosition,
        };

        this.fastMessage("view", viewData);
    }

    fastMessage(subtype, content) {
        const data = {
            type: "fast",
            subtype: subtype,
            data: content,
        };

        if (this.disabled) return;

        var blob = createBlobFromString(JSON.safeStringify(data));
        canv.intercom.socket.send(blob);
    }

    async sendEmoteMessage(x, y, url) {
        if (this.disabled) return;

        const data = {
            type: "emote",
            x: x,
            y: y,
            url: url,
        };

        var blob = createBlobFromString(JSON.safeStringify(data));
        canv.intercom.socket.send(blob);
    }

    async sendAiMessage(mode, action, selectedUIDs, targetWidgetUID, aiBeforeState) {
        if (this.disableAiEvents) {
            return;
        }
        //Для включения undo/redo-раскомментировать строки
        /* this.aiBeforeState = aiBeforeState; */

        const data = {
            type: 'aiRequest',
            mode,
            action,
            selectedUIDs,
            targetWidgetUID,
        }

        const blob = createBlobFromString(JSON.safeStringify(data));
        canv.intercom.socket.send(blob);
    }

    async processResponse(e) {
        const messageStr = await new Response(e.data).text();

        let messageOb;

        try {
            messageOb = JSON.parse(messageStr);
        } catch (e) {
            logException(new Error("websocket response bad format"));
            return;
        }

        if (messageOb.status === "failed") {
            logException(new Error("got status failed"));
            return;
        }

        if (messageOb.type === "descResponse") {
            canv.intercom.resolvers.requestDeskResolver(messageStr);
        }

        if (messageOb.type === "pingResponse") {
            canv.intercom.resolvers.pingResolver(messageStr);
        }

        if (messageOb.type === 'eventResponse' && messageOb.source === "ai") {

            const messageData = JSON.parse(messageOb.data).data;
            //Для включения undo/redo-раскомментировать строки
            /* canv.eventManager.createAndInsertAiTwinRecord(this.aiBeforeState, messageData); */
            for (const newData of messageData) {
                const widget = canv.canvasController.FindByUID(newData.UID);

                if (!widget) {
                    continue;
                }

                widget.loadState(newData.state, newData.fixType);
            }
            /* this.aiBeforeState = []; */
        }

        if (messageOb.type === "eventResponse") {
            try {
                canv.eventManager.proccessEventConfirm(messageOb);
            } catch (e) {
                logException(e);
                return;
            }
            canv.redraw();
        }

        if (messageOb.type === "initResponse") {
            canv.intercom.resolvers.initResolver(messageOb);
        }

        if (messageOb.type === "eventResponse") {
            const messageData = JSON.parse(messageOb.data)?.data;
            const isApplied = messageOb.isApplied;
            try {
                if (Array.isArray(messageData)) {
                    this.updateCommentsWindowData(messageData, isApplied);

                    if (isVoteCreateEvent(messageData[0])) {
                        canv.appInterface.voteWindow.close();
                        canv.canvasController.addVote(messageData[0].entities[0]);
                        this.updateActiveVoteWindow(messageData, isApplied);
                    }

                    if (isVoteEndedEvent(messageData[0]) && canv.canvasController.activeVote) {
                        const openResults = canv.appInterface.activeVote.isOpen;
                        canv.canvasController.deleteActiveVote();
                        canv.appInterface.activeVote.resetCurrentVoteInfo();
                        if (canv.isBoardModeEditOrOwner() && canv.isTeamMember() && openResults) {
                            canv.appInterface.voteWindow.showResultState();
                        } else {
                            canv.appInterface.voteWindow.resetTimer();
                        }
                        canv.appInterface.voteWindow.startModal?.unmount();
                        canv.appInterface.voteWindow.startModal = null;
                    }

                    if (["property", "propertyBuild", "build"].includes(messageData[0].type)) {
                        if (messageData[0]?.UID && messageData[0]?.UID === canv.canvasController?.activeVote?.UID) {
                            this.updateActiveVoteWindow(messageData, isApplied);
                        } else {
                            // todo добавить проверку, что это вообще событие голосования - достать из entities
                            this.updatePastVoteWindow(messageData, isApplied);
                        }
                    }
                }
            } catch (err) {
                console.error(
                    "processResponse, ошибка обновления списка комментариев, или голосования",
                    err,
                );
                canv.captureException(err);
            }
        }

        if (messageOb.type === "event") {
            const messageData = messageOb.data;
            const isApplied = true;

            if (!isVoteCreateEvent(messageData[0])) {
                try {
                    canv.eventManager.processIncomingRecord(messageData);
                } catch (e) {
                    logException(e);
                    return;
                }
                canv.redraw();
            }

            if (Array.isArray(messageData)) {
                try {
                    this.updateCommentsWindowData(messageData, isApplied);
                } catch (err) {
                    console.error(
                        "processResponse, ошибка обновления списка комментариев",
                        err,
                    );
                    canv.captureException(err);
                }

                if (isVoteCreateEvent(messageData[0])) {
                    canv.appInterface.voteWindow.close();
                    canv.canvasController.addVote(messageData[0].entities[0]);
                    this.triggerStartVoteWindow(messageData, isApplied);
                }

                if (isVoteEndedEvent(messageData[0]) && canv.canvasController.activeVote) {
                    const openResults = canv.appInterface.activeVote.isOpen;
                    canv.canvasController.deleteActiveVote();
                    canv.appInterface.activeVote.resetCurrentVoteInfo();
                    if (canv.isBoardModeEditOrOwner() && canv.isTeamMember() && openResults) {
                        canv.appInterface.voteWindow.showResultState();
                    } else {
                        canv.appInterface.voteWindow.resetTimer();
                    }
                    canv.appInterface.voteWindow.startModal?.unmount();
                    canv.appInterface.voteWindow.startModal = null;
                }

                if (["property", "propertyBuild", "build"].includes(messageData[0].type)) {
                    if (messageData[0]?.UID && messageData[0]?.UID === canv.canvasController?.activeVote?.UID) {
                        this.updateActiveVoteWindow(messageData, isApplied);
                    } else {
                        this.updatePastVoteWindow(messageData, isApplied);
                    }
                }
            }
        }

        if (messageOb.type === "fast") {
            if (messageOb["subtype"] === "view") {
                canv.multiManager.applyViewData(messageOb["data"]);
            } else if (messageOb["subtype"] === "select") {
                canv.multiManager.applySelectData(messageOb["data"]);
            } else if (messageOb["subtype"] === "timer") {
                canv.appInterface.timerWindow.proccessTimerMessage(messageOb["data"]);
            } else if (messageOb["subtype"] === "cursor_follow_invite") {
                canv.appInterface.cursorTrackingWindow.open(
                    messageOb["data"]["sessionUID"],
                );
            }
            canv.redraw();
        }
        if (messageOb.type === "multiUserDelete") {
            canv.multiManager.deleteMultiUser(messageOb["sessionUID"]);
        }

        if (messageOb.type === "emote") {
            canv.animator.createEmote(messageOb);
        }

        if (messageOb.type === 'aiResponse') {
            this.processAiResponse(messageOb);
        }
    }

    updateCommentsWindowData(messageData, isApplied) {
        // !!! используем только sanitizedCommentsActions, использование messageData напрямую не безопасно
        const sanitizedCommentsActions =
            returnSanitizedCommentActionEvents(messageData);
        updateCommentsMessages(sanitizedCommentsActions, isApplied);
        // updateList должен быть под updateCommentsMessages, так как updateCommentsMessages обновляет список items на доске
        canv.appInterface.commentsWindow.updateList(
            sanitizedCommentsActions,
            isApplied,
        );
    }

    triggerStartVoteWindow(messageData, isApplied) {
        const sanitizedVoteActions = returnSanitizedVoteActionEvents(messageData);

        if (
            sanitizedVoteActions.length &&
            sanitizedVoteActions[0].vote &&
            isApplied
        ) {
            const { creatorName, duration, UID } = sanitizedVoteActions[0].vote;
            if (!(canv.isBoardModeEditOrOwner() && canv.isTeamMember()) || typeof (+duration) !== "number" || !UID) return;
            canv.appInterface.voteWindow.showStartVoteWindow({
                creatorName,
                duration,
                UID,
            });
        }
    }

    updateActiveVoteWindow(messageData, isApplied) {
        const msg = messageData[0];
        const userToken = canv.getInitDataProp("userToken");
        const activeVote = canv.canvasController.activeVote;
        const { activeVote: activeVoteUI } = canv.appInterface;

        if (activeVoteUI && isApplied && msg.action !== 'create') {
            if (msg.type === "property") {
                handlePropertyUpdate(msg, activeVote);
            } else if (msg.type === "propertyBuild") {
                handlePropertyBuild(msg, activeVote);
            }
            if (activeVoteUI.isOpen) {
                activeVoteUI.update();
            }
            canv.appInterface.voteWindow.updateTimer()
            return;
        }

        if (
            msg.action === 'create' &&
            msg.entities[0].creatorToken === userToken &&
            isApplied
        ) {
            activeVoteUI.open();
        }
    }

    updatePastVoteWindow(messageData, isApplied) {
        if (!isApplied) return;
        const msg = messageData[0];
        if (msg.action === 'delete') {
            canv.canvasController.deletePastVote(msg.entities[0].UID);
            if (canv.appInterface.voteWindow.opened) {
                canv.appInterface.voteWindow.updatePastVoteList();
            }
        }

        if (msg.fixType === 'text') {
            canv.canvasController.renamePastVote(msg.UID, msg.state.text);
            if (canv.appInterface.voteWindow.opened) {
                canv.appInterface.voteWindow.updatePastVoteList();
            }
        }

    }

    processAiResponse(message) {
        if (message.status === 'error') {
            showSnackbar('Не удалось сгенерировать текст, попробуйте еще раз', { type: 'error', duration: SNACKBAR_TIMEOUT });
        }

        enableAiButton();
        this.disableAiEvents = false;
    }

    socket = null;
    disabled = false; // это значение используется в коде и может меняться на true в рантайме;
    disableEvents = false; // выключает отправку events. Не выключает fast
    disableAiEvents = false;
    /* aiBeforeState = []; */

    resolvers = {
        initResolver: () => { },
        requestDeskResolver: () => { },
        pingResolver: () => { },
    };
}
